var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-form",
    { ref: "editForm" },
    [
      _c(
        "c-card",
        { staticClass: "cardClassDetailForm", attrs: { title: "LBLDETAIL" } },
        [
          _c(
            "template",
            { slot: "card-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable && !_vm.disabled
                    ? _c("c-btn", {
                        attrs: {
                          isSubmit: _vm.isSave,
                          url: _vm.saveUrl,
                          param: _vm.assessPlan,
                          mappingType: _vm.mappingType,
                          label: "LBLSAVE",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveAssessPlan,
                          btnCallback: _vm.saveCallback,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-text", {
                  attrs: {
                    required: true,
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    label: "LBL0000367",
                    name: "assessmentName",
                  },
                  model: {
                    value: _vm.assessPlan.assessmentName,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "assessmentName", $$v)
                    },
                    expression: "assessPlan.assessmentName",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-datepicker", {
                  attrs: {
                    required: true,
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    range: true,
                    label: "LBL0000607",
                    name: "period",
                  },
                  model: {
                    value: _vm.assessPlan.assessmentPeriod,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "assessmentPeriod", $$v)
                    },
                    expression: "assessPlan.assessmentPeriod",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-datepicker", {
                  attrs: {
                    required: true,
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    default: "today",
                    type: "year",
                    label: "LBL0001000",
                    name: "assessmentYear",
                  },
                  model: {
                    value: _vm.assessPlan.assessmentYear,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "assessmentYear", $$v)
                    },
                    expression: "assessPlan.assessmentYear",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    required: true,
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    codeGroupCd: "RAM_ASSESS_TYPE_CD",
                    type: "edit",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "ramAssessTypeCd",
                    label: "LBL0001041",
                  },
                  model: {
                    value: _vm.assessPlan.ramAssessTypeCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "ramAssessTypeCd", $$v)
                    },
                    expression: "assessPlan.ramAssessTypeCd",
                  },
                }),
              ],
              1
            ),
            _vm.assessPlan.ramTechniqueCd !== "RT00000005" &&
            _vm.assessPlan.ramTechniqueCd !== "RT00000010" &&
            _vm.assessPlan.ramTechniqueCd !== "RT00000035"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                  },
                  [
                    _c("c-select", {
                      attrs: {
                        required: true,
                        editable: _vm.editable,
                        disabled: _vm.disabled,
                        comboItems: _vm.matrixItems,
                        type: "edit",
                        itemText: "matrixName",
                        itemValue: "ramMatrixId",
                        name: "ramMatrixId",
                        label: "Matrix",
                      },
                      model: {
                        value: _vm.assessPlan.ramMatrixId,
                        callback: function ($$v) {
                          _vm.$set(_vm.assessPlan, "ramMatrixId", $$v)
                        },
                        expression: "assessPlan.ramMatrixId",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-dept", {
                  attrs: {
                    required: true,
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    type: "edit",
                    label: "진행부서",
                    name: "assessmentManageDeptCd",
                    isFirstValue: false,
                  },
                  model: {
                    value: _vm.assessPlan.assessmentManageDeptCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "assessmentManageDeptCd", $$v)
                    },
                    expression: "assessPlan.assessmentManageDeptCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-plant", {
                  attrs: {
                    required: true,
                    disabled: _vm.disabled,
                    editable: _vm.editable,
                    type: "edit",
                    name: "plantCd",
                  },
                  model: {
                    value: _vm.assessPlan.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "plantCd", $$v)
                    },
                    expression: "assessPlan.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-text", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: true,
                    label: "LBLREGUSERNDATE",
                    name: "request",
                  },
                  model: {
                    value: _vm.request,
                    callback: function ($$v) {
                      _vm.request = $$v
                    },
                    expression: "request",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-vendor", {
                  attrs: {
                    disabled: _vm.disabled,
                    editable: _vm.editable,
                    label: "외부기관(업체)",
                    name: "vendorCd",
                  },
                  model: {
                    value: _vm.assessPlan.vendorCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "vendorCd", $$v)
                    },
                    expression: "assessPlan.vendorCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-field", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    data: _vm.assessPlan,
                    required: true,
                    type: "user",
                    label: "평가팀 리더",
                    name: "reviewUserId",
                  },
                  model: {
                    value: _vm.assessPlan.reviewUserId,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "reviewUserId", $$v)
                    },
                    expression: "assessPlan.reviewUserId",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-field", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    data: _vm.assessPlan,
                    required: true,
                    type: "user",
                    label: "평가자",
                    name: "approvalUserId",
                  },
                  model: {
                    value: _vm.assessPlan.approvalUserId,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "approvalUserId", $$v)
                    },
                    expression: "assessPlan.approvalUserId",
                  },
                }),
              ],
              1
            ),
            _vm.assessPlan.ramTechniqueCd === "RT00000015"
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                  },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: _vm.disabled,
                        label: "LBL0001055",
                        name: "workArea",
                      },
                      model: {
                        value: _vm.assessPlan.workArea,
                        callback: function ($$v) {
                          _vm.$set(_vm.assessPlan, "workArea", $$v)
                        },
                        expression: "assessPlan.workArea",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
              [
                _c("c-textarea", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    autogrow: "",
                    label: "LBL0001056",
                    name: "remark",
                  },
                  model: {
                    value: _vm.assessPlan.remark,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "remark", $$v)
                    },
                    expression: "assessPlan.remark",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
              [
                _c("c-construnction", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    name: "sopConstructionId",
                  },
                  model: {
                    value: _vm.assessPlan.sopConstructionId,
                    callback: function ($$v) {
                      _vm.$set(_vm.assessPlan, "sopConstructionId", $$v)
                    },
                    expression: "assessPlan.sopConstructionId",
                  },
                }),
              ],
              1
            ),
            _vm.isOcc && _vm.isOld
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                  },
                  [
                    _c(
                      "c-table",
                      {
                        ref: "table2",
                        attrs: {
                          title: "LBL0001061",
                          columns: _vm.gridOcc.columns,
                          gridHeight: _vm.gridOcc.height,
                          data: _vm.assessPlan.occasions,
                          filtering: false,
                          columnSetting: false,
                          usePaging: false,
                          editable: _vm.editable && !_vm.disabled,
                          selection: "multiple",
                          rowKey: "ramAssessmentOccasionId",
                        },
                      },
                      [
                        _c(
                          "template",
                          { slot: "table-button" },
                          [
                            _c(
                              "q-btn-group",
                              { attrs: { outline: "" } },
                              [
                                _vm.editable && !_vm.disabled
                                  ? _c("c-btn", {
                                      attrs: {
                                        showLoading: false,
                                        label: "LBLADD",
                                        icon: "add",
                                      },
                                      on: { btnClicked: _vm.addOccasion },
                                    })
                                  : _vm._e(),
                                _vm.editable && !_vm.disabled
                                  ? _c("c-btn", {
                                      attrs: {
                                        disabled:
                                          !_vm.assessPlan.occasions ||
                                          _vm.assessPlan.occasions.length === 0,
                                        label: "LBLREMOVE",
                                        icon: "remove",
                                      },
                                      on: {
                                        btnClicked: _vm.deleteAssessOccasion,
                                      },
                                    })
                                  : _vm._e(),
                                _vm.editable && !_vm.disabled
                                  ? _c("c-btn", {
                                      attrs: {
                                        disabled:
                                          !_vm.assessPlan.occasions ||
                                          _vm.assessPlan.occasions.length === 0,
                                        isSubmit: _vm.isSaveOccasion,
                                        url: _vm.saveOccasionUrl,
                                        param: _vm.assessPlan.occasions,
                                        mappingType: "PUT",
                                        label: "LBLSAVE",
                                        icon: "save",
                                      },
                                      on: {
                                        beforeAction: _vm.saveAssessOccasion,
                                        btnCallback: _vm.saveOccasionCallback,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _c("c-upload", {
                  staticClass: "q-pt-md",
                  attrs: {
                    attachInfo: _vm.attachInfo,
                    editable: _vm.editable && !_vm.disabled,
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }